module.exports = __webpack_public_path__ + "static/revat-competitions-71e8a90c9ab579081e52811d209f8f5c.jpg";